import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, useCallback, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import type { RefreshScheduleProps } from './RefreshSchedule.connect';
import { connectRefreshSchedule } from './RefreshSchedule.connect';

export const Component: FC<RefreshScheduleProps> = ({ refreshSchedule, tabId, formId, isDisabled, className }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const formInputDataChanged = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Reset schedule');
    refreshSchedule(tabId, formId);
  }, [tabId, formId, refreshSchedule, logAnalyticsCategory]);

  return (
    <div className="d-flex flex-row-reverse">
      <button
        className={classnames('btn text-primary btn-flat-primary btn-icon-end', className)}
        data-e2e="RefreshSchedule"
        disabled={isDisabled}
        onClick={formInputDataChanged}
      >
        <FormattedMessage id="form.RefreshSchedule" />
        <i className="icon">refresh</i>
      </button>
    </div>
  );
};

export const RefreshSchedule = connectRefreshSchedule(Component);

Component.displayName = 'RefreshSchedule';
